// GET Requests



// POST Requests
export const USERS_CONTACT = '/users/contact';
export const USERS_INVITE = '/users/invite';
export const USERS_LOGIN = '/users/login';



// WEBPACK FOOTER //
// ./src/constants/endpoints.jsx